import {module as Module} from 'modujs'

export default class extends Module {
    constructor(m) {
        super(m)

        // Bindings
        this.onKeydownBind = this.onKeydown.bind(this)
        this.onClickBind = this.onClick.bind(this)

        // UI
        this.$tabs = [...this.$('tab')]
        this.$panels = []

        // Data
        this.$firstTab = null
        this.$lastTab = null
    }

    init() {
        this.initTabs()
        this.setSelectedTab(this.$firstTab)
        this.bindEvents()
    }

    destroy() {
        super.destroy()
        this.unbindEvents()
    }

    bindEvents() {
        for (let i = 0; i < this.$tabs.length; i += 1) {
            const $tab = this.$tabs[i]
            $tab.addEventListener('keydown', this.onKeydownBind)
            $tab.addEventListener('click', this.onClickBind)
        }
    }

    unbindEvents() {
        for (let i = 0; i < this.$tabs.length; i += 1) {
            const $tab = this.$tabs[i]
            $tab.removeEventListener('keydown', this.onKeydownBind)
            $tab.removeEventListener('click', this.onClickBind)
        }
    }

    onKeydown(event) {
        let $target = event.currentTarget,
            flag = false

        switch (event.key) {
            case 'ArrowLeft':
                this.moveFocusToPreviousTab($target)
                flag = true
                break

            case 'ArrowRight':
                this.moveFocusToNextTab($target)
                flag = true
                break

            case 'Home':
                this.moveFocusToTab(this.$firstTab)
                flag = true
                break

            case 'End':
                this.moveFocusToTab(this.$lastTab)
                flag = true
                break

            default:
                break
        }

        if (flag) {
            event.stopPropagation()
            event.preventDefault()
        }
    }

    onClick(event) {
        this.setSelectedTab(event.currentTarget)
    }

    initTabs() {
        for (let i = 0; i < this.$tabs.length; i += 1) {
            const $tab = this.$tabs[i]

            $tab.tabIndex = -1
            $tab.setAttribute('aria-selected', 'false')
            const $tabpanel = this.el.querySelector(
                `#${$tab.getAttribute('aria-controls')}`
            )
            this.$panels.push($tabpanel)

            if (!this.$firstTab) {
                this.$firstTab = $tab
            }
            this.$lastTab = $tab
        }
    }

    setSelectedTab($currentTab) {
        for (let i = 0; i < this.$tabs.length; i += 1) {
            const $tab = this.$tabs[i]
            if ($currentTab === $tab) {
                $tab.setAttribute('aria-selected', 'true')
                $tab.removeAttribute('tabindex')
                this.$panels[i].classList.remove('is-hidden')
                this.$panels[i].hidden = false
                this.$panels[i].tabIndex = 0
                requestAnimationFrame(() => {
                    this.$panels[i].classList.add('is-active')
                    requestAnimationFrame(() => {
                        this.$panels[i].classList.add('is-inview')
                    })
                })
            } else {
                $tab.setAttribute('aria-selected', 'false')
                $tab.tabIndex = -1
                this.$panels[i].classList.add('is-hidden')
                this.$panels[i].classList.remove('is-active')
                this.$panels[i].classList.remove('is-inview')
                this.$panels[i].hidden = true
                this.$panels[i].tabIndex = -1
            }
        }
    }

    moveFocusToTab($currentTab) {
        $currentTab.focus()
    }

    moveFocusToPreviousTab($currentTab) {
        let index

        if ($currentTab === this.$firstTab) {
            this.moveFocusToTab(this.$lastTab)
        } else {
            index = this.$tabs.indexOf($currentTab)
            this.moveFocusToTab(this.$tabs[index - 1])
        }
    }

    moveFocusToNextTab($currentTab) {
        let index

        if ($currentTab === this.$lastTab) {
            this.moveFocusToTab(this.$firstTab)
        } else {
            index = this.$tabs.indexOf($currentTab)
            this.moveFocusToTab(this.$tabs[index + 1])
        }
    }
}
